/** text form and wp  */
export const IS_FIELD = "form.isField";
export const WP_FIELD = "wp.field";
export const WP_PROPS = "wp"
export const REQUIRED = "form.req";
export const IN_SUBJECT = "form.subj";
export const REPLY_TO = "form.reply";
export const LABEL = "form.label";
